import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { db } from '../FirebaseComp/firebase';
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import emailjs from "emailjs-com";
import { useNavigate } from 'react-router-dom';
import './member-registration.css';

const MemberRegistration = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    institutionName: "",
    brNo: "",
    establishedDate: "",
    address: "",
    telephone: "",
    email: "",
    website: "",
    divisionalSecretary: "",
    district: "",
    province: "",
    contactPerson: "",
    contactAddress: "",
    contactPhone: "",
    position: "",
    qualification: "",
    institutionType: {
      retailOptical: false,
      wholesale: false,
      investor: false,
      other: false,
      otherSpecify: ""
    },
    infrastructure: {},
    amenities: {}
  });

  const infrastructureItems = [
    "Auto Refractometer",
    "Lensometer",
    "Slit Lamp",
    "Phoropter",
    "Trial Set",
    "Edger",
    "Patternless Edger",
    "Manual Edger"
  ];

  const amenityItems = [
    "Waiting Area",
    "Parking",
    "Wheelchair Access",
    "Kids Area",
    "Restroom",
    "Wi-Fi"
  ];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (type === "checkbox") {
      if (name.includes("institutionType.")) {
        const field = name.split(".")[1];
        setFormData({
          ...formData,
          institutionType: {
            ...formData.institutionType,
            [field]: checked
          }
        });
      } else {
        setFormData({
          ...formData,
          [name]: checked
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleInfrastructureChange = (item, field, value) => {
    setFormData({
      ...formData,
      infrastructure: {
        ...formData.infrastructure,
        [item]: {
          ...formData.infrastructure[item],
          [field]: value
        }
      }
    });
  };

  const handleAmenitiesChange = (amenity, field, value) => {
    setFormData({
      ...formData,
      amenities: {
        ...formData.amenities,
        [amenity]: {
          ...formData.amenities[amenity],
          [field]: value
        }
      }
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await addDoc(collection(db, "optica-memberships"), {
        ...formData,
        createdAt: Timestamp.now()
      });

      await emailjs.send(
        "service_51az7kc",
        "template_5bnxs0i",
        {
          institutionName: formData.institutionName,
          brNo: formData.brNo,
          establishedDate: formData.establishedDate,
          address: formData.address,
          telephone: formData.telephone,
          email: formData.email,
          website: formData.website,
          divisionalSecretary: formData.divisionalSecretary,
          district: formData.district,
          province: formData.province,
          contactPerson: formData.contactPerson,
          contactAddress: formData.contactAddress,
          contactPhone: formData.contactPhone,
          position: formData.position,
          qualification: formData.qualification,
          institutionType: Object.entries(formData.institutionType)
            .filter(([key, value]) => key !== "otherSpecify" && value)
            .map(([key]) => key)
            .concat(formData.institutionType.otherSpecify ? [formData.institutionType.otherSpecify] : [])
            .join(", ")
        },
        "9lJhqwxrUymjuxthV"
      );

      alert("Registration submitted successfully!");
      navigate('/'); // Navigate back to home or thank you page
      resetForm();
    } catch (error) {
      console.error("Submission Error:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetForm = () => {
    setFormData({
      institutionName: "",
      brNo: "",
      establishedDate: "",
      address: "",
      telephone: "",
      email: "",
      website: "",
      divisionalSecretary: "",
      district: "",
      province: "",
      contactPerson: "",
      contactAddress: "",
      contactPhone: "",
      position: "",
      qualification: "",
      institutionType: {
        retailOptical: false,
        wholesale: false,
        investor: false,
        other: false,
        otherSpecify: ""
      },
      infrastructure: {},
      amenities: {}
    });
  };

  return (
    <div className="registration-page">
      {/* Header/Navigation */}
      <div className="registration-header">
        <div className="container">
          <button className="back-btn" onClick={() => navigate(-1)}>
            ← Back
          </button>
          <h1>Optica International</h1>
          <p>Membership Registration</p>
        </div>
      </div>

      {/* Main Content */}
      <motion.div 
        className="registration-container"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="registration-wrapper">
          <div className="registration-header-content">
            <h2>Become a Member Today</h2>
            <p>Join Optica International and gain access to exclusive products, technical support, training updates, and special pricing.</p>
          </div>

          <form onSubmit={handleSubmit} className="registration-form">
            {/* Institution Details */}
            <div className="form-section">
              <h3>Institution Details</h3>
              <div className="form-grid">
                <div className="form-group">
                  <label>Institution Name <span className="required">*</span></label>
                  <input
                    type="text"
                    name="institutionName"
                    value={formData.institutionName}
                    onChange={handleChange}
                    required
                    placeholder="Enter institution name"
                  />
                </div>

                <div className="form-group">
                  <label>BR No <span className="required">*</span></label>
                  <input
                    type="text"
                    name="brNo"
                    value={formData.brNo}
                    onChange={handleChange}
                    required
                    placeholder="Business registration number"
                  />
                </div>

                <div className="form-group">
                  <label>Established Date</label>
                  <input
                    type="date"
                    name="establishedDate"
                    value={formData.establishedDate}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group full-width">
                  <label>Address <span className="required">*</span></label>
                  <textarea
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    required
                    rows="2"
                    placeholder="Full address"
                  />
                </div>

                <div className="form-group">
                  <label>Telephone <span className="required">*</span></label>
                  <input
                    type="tel"
                    name="telephone"
                    value={formData.telephone}
                    onChange={handleChange}
                    required
                    placeholder="Contact number"
                  />
                </div>

                <div className="form-group">
                  <label>Email <span className="required">*</span></label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="Email address"
                  />
                </div>

                <div className="form-group">
                  <label>Website</label>
                  <input
                    type="text"
                    name="website"
                    value={formData.website}
                    onChange={handleChange}
                    placeholder="Website"
                  />
                </div>
              </div>
            </div>

            {/* Location Details */}
            <div className="form-section">
              <h3>Location Details</h3>
              <div className="form-grid">
                <div className="form-group">
                  <label>Divisional Secretary</label>
                  <input
                    type="text"
                    name="divisionalSecretary"
                    value={formData.divisionalSecretary}
                    onChange={handleChange}
                    placeholder="Divisional secretary area"
                  />
                </div>

                <div className="form-group">
                  <label>District</label>
                  <input
                    type="text"
                    name="district"
                    value={formData.district}
                    onChange={handleChange}
                    placeholder="District"
                  />
                </div>

                <div className="form-group">
                  <label>Province</label>
                  <input
                    type="text"
                    name="province"
                    value={formData.province}
                    onChange={handleChange}
                    placeholder="Province"
                  />
                </div>
              </div>
            </div>

            {/* Contact Person Details */}
            <div className="form-section">
              <h3>Contact Person Details</h3>
              <div className="form-grid">
                <div className="form-group">
                  <label>Contact Person <span className="required">*</span></label>
                  <input
                    type="text"
                    name="contactPerson"
                    value={formData.contactPerson}
                    onChange={handleChange}
                    required
                    placeholder="Full name"
                  />
                </div>

                <div className="form-group full-width">
                  <label>Contact Address</label>
                  <textarea
                    name="contactAddress"
                    value={formData.contactAddress}
                    onChange={handleChange}
                    rows="2"
                    placeholder="Contact person's address"
                  />
                </div>

                <div className="form-group">
                  <label>Contact Phone <span className="required">*</span></label>
                  <input
                    type="tel"
                    name="contactPhone"
                    value={formData.contactPhone}
                    onChange={handleChange}
                    required
                    placeholder="Phone number"
                  />
                </div>

                <div className="form-group">
                  <label>Position</label>
                  <input
                    type="text"
                    name="position"
                    value={formData.position}
                    onChange={handleChange}
                    placeholder="Job title/position"
                  />
                </div>

                <div className="form-group">
                  <label>Qualification</label>
                  <input
                    type="text"
                    name="qualification"
                    value={formData.qualification}
                    onChange={handleChange}
                    placeholder="Professional qualifications"
                  />
                </div>
              </div>
            </div>

            {/* Institution Type */}
            <div className="form-section">
              <h3>Institution Type</h3>
              <div className="checkbox-group">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    name="institutionType.retailOptical"
                    checked={formData.institutionType.retailOptical}
                    onChange={handleChange}
                  />
                  <span>Retail Optical</span>
                </label>

                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    name="institutionType.wholesale"
                    checked={formData.institutionType.wholesale}
                    onChange={handleChange}
                  />
                  <span>Wholesale</span>
                </label>

                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    name="institutionType.investor"
                    checked={formData.institutionType.investor}
                    onChange={handleChange}
                  />
                  <span>Investor</span>
                </label>

                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    name="institutionType.other"
                    checked={formData.institutionType.other}
                    onChange={handleChange}
                  />
                  <span>Other</span>
                </label>

                {formData.institutionType.other && (
                  <div className="form-group other-specify">
                    <input
                      type="text"
                      name="institutionType.otherSpecify"
                      value={formData.institutionType.otherSpecify}
                      onChange={handleChange}
                      placeholder="Please specify"
                    />
                  </div>
                )}
              </div>
            </div>

            {/* Infrastructure */}
            <div className="form-section">
              <h3>Available Infrastructure</h3>
              <p className="section-note">Please indicate the equipment available at your facility</p>
              <div className="infrastructure-grid">
                {infrastructureItems.map((item) => (
                  <div key={item} className="infrastructure-item">
                    <h4>{item}</h4>
                    <div className="radio-group">
                      <label>
                        <input
                          type="radio"
                          name={`infrastructure.${item}`}
                          value="available"
                          onChange={() => handleInfrastructureChange(item, 'status', 'available')}
                        /> Available
                      </label>
                      <label>
                        <input
                          type="radio"
                          name={`infrastructure.${item}`}
                          value="not-available"
                          onChange={() => handleInfrastructureChange(item, 'status', 'not-available')}
                        /> Not Available
                      </label>
                    </div>
                    <input
                      type="text"
                      placeholder="Make/Model (optional)"
                      onChange={(e) => handleInfrastructureChange(item, 'details', e.target.value)}
                      className="details-input"
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Amenities */}
            <div className="form-section">
              <h3>Amenities</h3>
              <p className="section-note">Please select the amenities available at your facility</p>
              <div className="amenities-grid">
                {amenityItems.map((amenity) => (
                  <div key={amenity} className="amenity-item">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        onChange={(e) => handleAmenitiesChange(amenity, 'available', e.target.checked)}
                      />
                      <span>{amenity}</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Details (optional)"
                      onChange={(e) => handleAmenitiesChange(amenity, 'details', e.target.value)}
                      className="details-input"
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Form Actions */}
            <div className="form-actions">
              <button type="button" className="cancel-btn" onClick={() => navigate('/')}>
                Cancel
              </button>
              <button 
                type="submit" 
                className="submit-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Submitting...' : 'Submit Registration'}
              </button>
            </div>
          </form>
        </div>
      </motion.div>
    </div>
  );
};

export default MemberRegistration;